// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"4890c63bd92e392a","1043":"88eb61a2cf8eef93","2715":"b8a11a98cbb6bfb5","2722":"0f79dbe9ea1e3c77","7584":"d9652db206d50763","9755":"973b02e096d97318"}[chunkId] + ".css";
};